import React from "react"

import {useAuth} from "../context"

function RequireAuth({children}) {
    let auth = useAuth()

    if (!auth.loaded) {
        return <div>auth loading...</div>
    }

    if (auth.loaded && !auth.user) {
        // @ts-ignore
        window.location = "/login"
        return <div>redirecting...</div>
    }
    return children
}

export default RequireAuth